import {
  GET_INTERNSHIPS,
  GET_INTERNSHIPS_FAIL,
  GET_INTERNSHIPS_SUCCESS,
  ADD_NEW_INTERNSHIP,
  ADD_INTERNSHIP_SUCCESS,
  ADD_INTERNSHIP_FAIL,
  UPDATE_INTERNSHIP,
  UPDATE_INTERNSHIP_SUCCESS,
  UPDATE_INTERNSHIP_FAIL,
  DELETE_INTERNSHIP,
  DELETE_INTERNSHIP_SUCCESS,
  DELETE_INTERNSHIP_FAIL,
  
} from "./actionTypes";

export const getInternships = () => ({
  type: GET_INTERNSHIPS,
})

export const getInternshipsSuccess = internships => ({
  type: GET_INTERNSHIPS_SUCCESS,
  payload: internships,
})

export const getInternshipsFail = error => ({
  type: GET_INTERNSHIPS_FAIL,
  payload: error,
})

export const addNewInternship = internship => ({
  type: ADD_NEW_INTERNSHIP,
  payload: internship,
})

export const addInternshipSuccess = internship => ({
  type: ADD_INTERNSHIP_SUCCESS,
  payload: internship,
})

export const addInternshipFail = error => ({
  type: ADD_INTERNSHIP_FAIL,
  payload: error,
})

export const updateInternship = internship => ({
  type: UPDATE_INTERNSHIP,
  payload: internship,
})

export const updateInternshipSuccess = internship => ({
  type: UPDATE_INTERNSHIP_SUCCESS,
  payload: internship,
})

export const updateInternshipFail = error => ({
  type: UPDATE_INTERNSHIP_FAIL,
  payload: error,
})

export const deleteInternship = data => ({
  type: DELETE_INTERNSHIP,
  payload: data,
})

export const deleteInternshipSuccess = data => ({
  type: DELETE_INTERNSHIP_SUCCESS,
  payload: data,
})

export const deleteInternshipFail = error => ({
  type: DELETE_INTERNSHIP_FAIL,
  payload: error,
})

